import { Card } from '@/components/Card';

export function EventCardSkeleton() {
    return <Card loading />;
}
